/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Company_Registration_Closed_ErrorInputs */

const en_company_registration_closed_error = /** @type {(inputs: Company_Registration_Closed_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Company registration is closed. New company registrations cannot currently be submitted.`)
};

const de_company_registration_closed_error = /** @type {(inputs: Company_Registration_Closed_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Anmeldung für Unternehmen ist geschlossen. Es können derzeit keine neuen Unternehmensregistrierungen eingereicht werden.`)
};

/**
* | output |
* | --- |
* | "Company registration is closed. New company registrations cannot currently be submitted." |
*
* @param {Company_Registration_Closed_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const company_registration_closed_error = /** @type {((inputs?: Company_Registration_Closed_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Company_Registration_Closed_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_company_registration_closed_error(inputs)
	return en_company_registration_closed_error(inputs)
});